var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-image',{attrs:{"output":"file"},on:{"select":_vm.getImageSource}})
}
var staticRenderFns = []

export { render, staticRenderFns }